
import TodoContext from "../todoCtx/TdoCtx";
import "./addItem.css"

import React, { useContext } from 'react';
import moment from 'moment';
moment().format();

const AddItem = () => {

  const {todos,setTodos,writeTask,setWriteTask} = useContext(TodoContext);

  

  const addInputHandler = event =>{
    
    setWriteTask(event.target.value.replace(/[^a-z ]/gi, ''));
  }


const addTodo = text => {



    const newTodos = [{ fullName : writeTask, email : "", number : "", class : "", id : moment().unix(), isMarked : false, bgColor : "", color : "", counter : 0 }, ...todos];

    setTodos(newTodos);

    setWriteTask(""); //add krny k baad input ko empty

  

};


  

  return (
    <>
    <div className='addItem'>

        <input id='writeTask' name='writeTask' className='addItemInput' type="text" placeholder='Add Student' value={writeTask} onChange={addInputHandler} maxLength="20" />
        <button onClick={addTodo} className="addItemButton" >Add Student</button>

    </div>

   



      

   
      
        
        
   

    </>)
}

export default AddItem